import { parseResponse } from "helpers/common.lib";
import { baseApi } from "../../redux/baseAPI";

export const fbApi = baseApi.injectEndpoints({
  tagTypes: ["FB", "RosDetails", "SYSTEM", "NoteRos"],
  endpoints: (builder) => ({
    getRos: builder.query({
      query: (queryParams) => {
        return {
          // url: `/form_builder/index_smart.json`,
          url: `/form_builder/index.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => {return parseResponse(response);},
      providesTags: ["FB"],
    }),
    getRosDetail: builder.query({
      query: (queryParams) => {
        return {
          url: `/form_builder/details.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: [(result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "RosDetails", id })),
              { type: "RosDetails", id },
            ]
          : [{ type: "RosDetails", id }]],
    }),
    getNoteRos: builder.query({
      query: (queryParams) => {
        return {
          url: `/physical_exams/get_ros_against_encounter.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["NoteRos"],
    }),
    getRosSystems: builder.query({
      query: (queryParams) => {
        return {
          url: `/patients/get_ros.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["SYSTEM"],
    }),
    getExams: builder.query({
      query: (queryParams) => {
        return {
          url: `/physical_exams/index.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "FB", id })),
              { type: "FB", id: "Exam" },
            ]
          : [{ type: "FB", id: "Exam" }],
    }),
    saveFb: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (data) => {
        return {
          url: `/form_builder/add.json`,
          method: "POST",
          data: data,
        }
      },
      transformResponse: (response, meta, arg) => response.response.data.current,
      // async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
      //   const patchResult = dispatch(
      //     fbApi.util.updateQueryData("getRos", id, (draft) => {
      //       Object.assign(draft, patch);
      //     })
      //   );
      //   try {
      //     await queryFulfilled;
      //   } catch {
      //     patchResult.undo();
      //   }
      // },
      invalidatesTags: ["FB"],
    }),
    updateRosPe: builder.mutation({
      // note: an optional `queryFn` may be used in place of `query`
      query: (data) => ({
        url: `/physical_exams/save_review_of_system.json`,
        method: "POST",
        data: data,
        params: {pid: data.pid},
      }),
      transformResponse: (response, meta, arg) => response,
      // async onQueryStarted({ pid, ...patch }, { dispatch, queryFulfilled }) {
      //   console.log('pos1',patch);
      //   const patchResult = dispatch(
      //     fbApi.util.updateQueryData("getNoteRos", {pid}, (draft) => {
      //       console.log('pos2',draft);
      //       if(draft){
      //         Object.assign(draft || {}, patch);
      //       }else{
      //         draft = {...patch};
      //       }
      //     })
      //   );
      //   try {
      //     await queryFulfilled;
      //   } catch {
      //     patchResult.undo();
      //   }
      // },
      // invalidatesTags: (result, error, { id }) => [{ type: "NoteRos", id }],
    }),
    makeRosTemplateDefault: builder.mutation({
      query: (data, params) => ({
        url: `/form_builder/make_default.json`,
        method: "POST",
        data: data,
        params: params,
      }),
      transformResponse: (response, meta, arg) => response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          fbApi.util.updateQueryData("getRos", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["FB"],
    }),
    copyRosTemplate: builder.mutation({
      query: (data, params) => ({
        url: `/form_builder/copy.json`,
        method: "POST",
        data: data,
        params: params,
      }),
      transformResponse: (response, meta, arg) => response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          fbApi.util.updateQueryData("getRos", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["FB"],
    }),
    deleteRosTemplate: builder.mutation({
      query: (data, params) => ({
        url: `/form_builder/delete.json`,
        method: "POST",
        data: data,
        params: params,
      }),
      transformResponse: (response, meta, arg) => response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          fbApi.util.updateQueryData("getRos", id, (draft) => {
            Object.assign(draft, patch);
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["FB"],
    }),
  }),
});

export const { 
  useGetRosQuery, 
  useGetNoteRosQuery, 
  useSaveFbMutation, 
  useGetRosSystemsQuery, 
  useUpdateRosPeMutation,
  useMakeRosTemplateDefaultMutation,
  useCopyRosTemplateMutation,
  useDeleteRosTemplateMutation 
} = fbApi;